import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class NewOrderSelectApiService {
  private baseHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey);

  constructor(private http: HttpClient) {}

  getSelect(option: string, params: string, tenantCode?: string): Observable<any[]> {
    const isPublic = !!tenantCode;
    const headers = isPublic ? this.baseHeaders.set('tennantCode', tenantCode as string) : this.baseHeaders;
    const prefix = isPublic ? 'Public/' : '';
    const url = `${environment.APIM}${environment.newOrderAPI}${prefix}${option}${params || ''}`;
    return this.http.get<any[]>(url, { headers });
  }
}
